module.exports = __webpack_public_path__ + "img/type--3-spans--single-lang--pt.41b0dc4e.jpg";